import { Space, Tabs } from "antd";
import HeaderSection from "../../components/HeaderSection";
import MaskingTable from "./components/MaskingTable";
import HistoryMaskingTable from "./components/HistoryMaskingTable";
import { useState } from "react";
import useAuth from "../../hooks/useAuth";

const MaskingList: React.FC = () => {
	const [activeTab, setActiveTab] = useState("masking");
	const { isAgent } = useAuth();
	return (
		<>
			<Space direction="vertical">
				<>
					<HeaderSection
						title="Data Masking"
						tabsComponent={
							<Tabs
								renderTabBar={(props, TabNavList) => (
									<TabNavList
										{...props}
										mobile={true}
									/>
								)}
								onChange={(key) => setActiveTab(key)}
								items={[
									{
										key: "masking",
										label: "Data Masking",
									},
									{
										key: "history",
										label: isAgent ? "My Masking History" : "Masking History",
									},
								]}
							/>
						}
					/>

					{activeTab === "masking" ? (
						<MaskingTable />
					) : activeTab === "history" ? (
						<HistoryMaskingTable />
					) : (
						<></>
					)}
				</>
			</Space>
		</>
	);
};
export default MaskingList;
